import { useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Descriptions, Flex, Grid, Image, Modal, Row, Typography } from "antd";
import { Link, useParams } from "react-router";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useState } from "react";
import { surveyService } from "../../../services/survey.service";
import { API_BASE_URL } from "../../../config/api.config";
import pallete from "../../../utils/pallete";
import { getFileExtension } from "../../../utils/getFileExtension";


export default function FinishRegistrationDetail(){

  const { id } = useParams()

  const [previewImage, setPrevieImage] = useState('')

  const breakpoint = Grid.useBreakpoint()

  const { data: surveyData } = useQuery({
    queryKey: ['detailFinishData', id],
    queryFn: () => surveyService.getFinishDataById(id)
  })

  const registration = surveyData?.data?.acceptance?.registration

  return (
    <>
      <Card
        title="Detail Data Terpasang"
        extra={
          <Link target="_blank" to={`${API_BASE_URL}/registration/export/${registration?.id}`}>
            <Button
              icon={<Icon icon="solar:download-square-bold-duotone" width="18" height="18" />}
              color="primary"
              variant="filled"
            >
              Unduh
            </Button>
          </Link>
        }
      >
        <Descriptions
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          style={{ marginBottom: 20 }}
          title="Informasi Pelanggan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'Nama Pelanggan', children: surveyData?.data?.nama },
              { label: 'No Telepon', children: surveyData?.data?.telepon },
              { label: 'No KTP', children: surveyData?.data?.no_nik },
              { label: 'No KK', children: surveyData?.data?.no_kk },
              { label: 'No PBB', children: surveyData?.data?.no_pbb },
              { label: 'No Sertifikat', children: surveyData?.data?.no_sertifikat },
              { label: 'No Telepon', children: surveyData?.data?.telepon },
              { label: 'Email', children: surveyData?.data?.email },
              { label: 'Kota', children: surveyData?.data?.kota },
              { label: 'Kecamatan', children: surveyData?.data?.kecamatan },
              { label: 'Kelurahan', children: surveyData?.data?.kelurahan },
              { label: 'Jalan', children: surveyData?.data?.jalan },
              { span: 1, label: 'No Rumah', children: surveyData?.data?.no_rumah },
              { span: 0.5, label: 'RT', children: surveyData?.data?.rt?.toString().padStart(3,'0') },
              { span: 0.5, label: 'RW', children: surveyData?.data?.rw?.toString().padStart(3,'0') },
              { label: 'Status Penghuni', children: surveyData?.data?.status_penghuni },
              { label: 'Jumlah Penghuni', children: surveyData?.data?.jumlah_penghuni },
              { label: 'Lingkungan Tertata', children: surveyData?.data?.lingkungan_tertata },
              { label: 'Jenis Pemukiman', children: surveyData?.data?.jenis_pemukiman?.name },
              { label: 'Kode Tarif', children: surveyData?.data?.kode_tarif?.name },
              { label: 'Luas Bangunan', children: surveyData?.data?.luas_bangunan + ' m2' },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Titik Lokasi Koordinat"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'Titik Lokasi Koordinat', children: surveyData?.data?.lokasi_bangunan },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Lokasi"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'PA/PC',  children: surveyData?.data?.ab?.PAPC_CODE },
            { label: 'BLOK/EZ', children: surveyData?.data?.ab?.AREA == 'WEST' ? surveyData?.data?.ab?.BLOCKNO : surveyData?.data?.ab?.EZ_CODE },
            { label: 'NOVAK/BLOK', children: surveyData?.data?.novak_blok },
            { label: 'Nomen Terdekat', children: surveyData?.data?.nomen_terdekat },
            { label: 'Sumber air lain yang digunakan pelanggan', span: 2, children: surveyData?.data?.sumber_lain },
            { label: 'Jaringan Pipa', children: surveyData?.data?.jaringan_pipa },
            { label: 'Jarak bangunan dengan pipa existing PAM JAYA', children: surveyData?.data?.jarak_bangunan_dengan_pipa },
            { label: 'Ukuran Pipa Input ', children: surveyData?.data?.ukuran_pipa?.name },
            { label: 'Diameter Pipa Dinas yang akan dipasang', children: surveyData?.data?.diameter_pipa?.name },
            { label: 'Jenis jalan/gailan', children: surveyData?.data?.jenis_jalan?.name },
            { label: 'Perlu crosing jalan', children: surveyData?.data?.perlu_crossing_jalan == 'Y' ? 'Ya' : 'Tidak' },
            { label: 'Lebar Jalan', children: surveyData?.data?.lebar_jalan },
            { label: 'Perlu crossing saluran air', children: surveyData?.data?.perlu_crossing_air == 'Y' ? 'Ya' : 'Tidak'},
            { label: 'Panjang casing pipa', children: surveyData?.data?.panjang_casing_pipa + ' m'},
            { label: 'Halaman', children: surveyData?.data?.halaman == 'Y' ? 'Ya' : 'Tidak' },
            { label: 'Sanitasi', children: surveyData?.data?.sanitasi  == 'Y' ? 'Ya' : 'Tidak' },
            { label: 'Saluran Pembuangan', children: surveyData?.data?.saluran_pembuangan == 'Y' ? 'Ya' : 'Tidak' },
            { label: 'Golongan Konsumen', children: surveyData?.data?.golongan_konsumen?.name },
            { label: 'Nomen Lama', children: surveyData?.data?.nomen_lama },
            { label: 'Tekanan Air', children: surveyData?.data?.tekanan_air + ' m'},
            { label: 'Peruntukan Bangunan', children: surveyData?.data?.peruntukan_bangunan == 'D' ? 'Domestic' : 'Non Domestic'},
            { label: 'Perlu Bor Tembok', children: surveyData?.data?.perlu_bor_tembok == 'Y' ? 'Ya' : 'Tidak'},
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Bangunan"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { label: 'Kamar Tidur',  children: surveyData?.data?.kamar_tidur },
            { label: 'Kamar Mandi',  children: surveyData?.data?.kamar_mandi },
            { label: 'Ruang Tamu',  children: surveyData?.data?.ruang_tamu },
            { label: 'Ruang Makan',  children: surveyData?.data?.ruang_makan },
            { label: 'Ruang Keluarga',  children: surveyData?.data?.ruang_keluarga },
            { label: 'Dapur',  children: surveyData?.data?.dapur },
            { label: 'Teras',  children: surveyData?.data?.teras },
            { label: 'Garasi',  children: surveyData?.data?.garasi },
            { label: 'Gudang/Paviliun',  children: surveyData?.data?.gudang },
            { label: 'Lantai',  children: surveyData?.data?.jumlah_lantai },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Dokumen"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.ktp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.ktp}
                    >
                      <Link to={ registration?.ktp && `${API_BASE_URL}/files/registration/${registration?.ktp}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.ktp}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'KK', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.kk}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.kk}
                    >
                      <Link to={registration?.kk && `${API_BASE_URL}/files/registration/${registration?.kk}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.kk}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.pbb}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.pbb}
                    >
                      <Link to={registration?.pbb && `${API_BASE_URL}/files/registration/${registration?.pbb}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.pbb}`)}
                      disabled={!registration?.pbb}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'Bangunan', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.bangunan}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!registration?.bangunan}
                    >
                      <Link to={registration?.bangunan && `${API_BASE_URL}/files/registration/${registration?.bangunan}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.bangunan}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'Surat Pelayanan Sementara', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.serviceLetter?.fileName}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!surveyData?.data?.serviceLetter?.fileName}
                    >
                      <Link to={surveyData?.data?.serviceLetter?.fileName && `${API_BASE_URL}/files/registration/${surveyData?.data?.serviceLetter?.filePath}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      disabled={!surveyData?.data?.serviceLetter?.fileName}
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/${surveyData?.data?.serviceLetter?.filePath}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            ...surveyData?.data?.additionalLetter.map(
              (e,i) => ({
                label: i == 0 ? 'Dokumen Pendukung' : '',
                children: (
                  <Flex gap={8} align="center" >
                    <Typography.Text style={{ marginRight: 'auto' }}>{e?.fileName}</Typography.Text>
                    <Flex vertical={!breakpoint.lg} gap={8} >
                      <Button 
                        icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                        variant="filled" 
                        color="primary" 
                        size="small" 
                        style={{ fontSize: 12 }} 
                      >
                        <Link to={e.fileName && `${API_BASE_URL}/files/${e.filePath}`} >
                          Unduh
                        </Link>
                      </Button>
                      <Button 
                        variant="filled" 
                        color="primary" 
                        size="small" 
                        style={{ fontSize: 12 }} 
                        icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                        onClick={() => setPrevieImage(`${API_BASE_URL}/files/${e.filePath}`)}
                      >
                        Lihat
                      </Button>
                    </Flex>
                    
                  </Flex>
                )
              })
            ) ?? []
          ]}
        />
        <Typography.Title level={5} >
          Persetujuan
        </Typography.Title>
        <Row>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_pelanggan}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.nama}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Pelanggan
              </Typography.Text>
            </Flex>
          </Col>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_surveyor}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.acceptance?.surveyor?.name}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Surveyor
              </Typography.Text>
            </Flex>
          </Col>
        </Row>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={()=> setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <embed style={{ width: '100%', height: getFileExtension(previewImage) == 'pdf' && '500px' }} src={previewImage} />
      </Modal>
    </>
  ) 
}